import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "动画剧情", to: "/category/animation" },
  { label: "角色分析", to: "/category/character" },
  { label: "动漫资讯", to: "/category/news" },
  { label: "搜索", to: "/search" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const transparent = isHome && !scrolled;

  const idleText = transparent
    ? "text-background-50/85 hover:text-background-50"
    : "text-foreground-600 hover:text-primary-600";
  const activeText = transparent ? "text-background-50" : "text-primary-600";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        transparent
          ? "bg-transparent"
          : "border-b border-background-200 bg-background-50/95 backdrop-blur"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between md:h-20">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-book-2-line text-lg" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg font-bold ${
                  transparent ? "text-background-50" : "text-foreground-950"
                }`}
              >
                家庭教师
              </span>
              <span
                className={`mt-0.5 text-[10px] tracking-widest ${
                  transparent ? "text-background-50/70" : "text-foreground-400"
                }`}
              >
                动画剧情 · 角色解析
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive ? activeText : idleText
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/search"
              aria-label="搜索"
              className={`hidden h-9 w-9 items-center justify-center rounded-md transition-colors md:flex ${
                transparent ? "text-background-50 hover:bg-background-50/15" : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              <i className="ri-search-line text-lg" aria-hidden="true" />
            </Link>
            <Link
              to="/category/news"
              className="hidden items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 md:flex whitespace-nowrap"
            >
              <i className="ri-flashlight-line" aria-hidden="true" />
              最新动态
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen(true)}
              className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors md:hidden ${
                transparent ? "text-background-50 hover:bg-background-50/15" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <i className="ri-menu-3-line text-xl" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 md:hidden">
          <button
            type="button"
            aria-label="关闭菜单"
            onClick={() => setOpen(false)}
            className="absolute inset-0 bg-foreground-950/50"
          />
          <div className="absolute right-0 top-0 flex h-full w-72 max-w-[80%] flex-col bg-background-50">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <span className="font-heading text-base font-bold text-foreground-950">
                导航
              </span>
              <button
                type="button"
                aria-label="关闭菜单"
                onClick={() => setOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-600 hover:bg-background-100"
              >
                <i className="ri-close-line text-xl" aria-hidden="true" />
              </button>
            </div>
            <nav className="flex flex-col gap-1 p-4">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-50 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line" aria-hidden="true" />
                </NavLink>
              ))}
            </nav>
            <div className="mt-auto p-4">
              <Link
                to="/category/news"
                className="flex items-center justify-center gap-2 rounded-md bg-accent-500 px-4 py-3 text-sm font-medium text-background-50"
              >
                <i className="ri-flashlight-line" aria-hidden="true" />
                查看最新动态
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}